import { IonContent, IonNav } from "@ionic/react";

interface ComponentProps {
    component: React.ComponentType<any>;
}

const BaseModalComponent: React.FC<ComponentProps> = ({ component }) => {
    
    return (
        <IonContent>
            <IonNav root={component} />
        </IonContent>
    );
}

export default BaseModalComponent